import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';
import classes from './LocationFilter.module.scss';
import BasicFilterDropdown from '../BasicFilterDropdown/BasicFilterDropdown';
import BasicDropdownOption from '../BasicDropdownOption/BasicDropdownOption';
import { useWindowSize } from '../../../../../../utils/hooks';
import { responsiveSizeTimesheet } from '../../../../../../utils/constants';

export default function LocationFilter({ locations, selectedLocation, changeLocation }) {
  const { t } = useTranslation();
  const size = useWindowSize();

  const [open, setOpen] = useState(false);

  return (
    <BasicFilterDropdown
      type={t('dashboard.timesheets.filters.location')}
      text={
        !selectedLocation || selectedLocation === t('common.general.all')
          ? t('dashboard.timesheets.filters.location')
          : selectedLocation
      }
      active={!!selectedLocation && selectedLocation !== t('common.general.all')}
      open={open}
      setOpen={setOpen}
    >
      <div className={classes.container}>
        {locations.map((location) =>
          size.width > responsiveSizeTimesheet ? (
            <BasicDropdownOption
              key={location}
              text={location}
              selected={selectedLocation === location}
              clickHandler={() => {
                changeLocation(location);
                setOpen(false);
              }}
            />
          ) : (
            <Chip
              variant={selectedLocation === location ? 'filled' : 'outlined'}
              key={location}
              label={location || t('common.general.all')}
              onClick={() => {
                changeLocation(location);
              }}
              sx={{
                '&.MuiChip-root': {
                  backgroundColor: selectedLocation === location ? '#003B58' : '#F6F7F9',
                  color: selectedLocation === location ? '#FFFFFF' : '#77787B',
                  fontStyle: 'normal',
                  fontWeight: '600',
                  fontSize: '16px',
                  lineHeight: '19px'
                }
              }}
            />
          )
        )}
      </div>
    </BasicFilterDropdown>
  );
}
